import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageService, UploadResult } from '../../core/storage';
import { IncidenceDbService } from './incidence-db.service';
import { IncidenceUI } from './incidence.models';

@Injectable({ providedIn: 'root' })
export class IncidenceService {
  private incidenceDbService = inject(IncidenceDbService);
  private storageService = inject(StorageService);

  uploadIncidenceFile(file: File, incidenceId: string): Observable<UploadResult> {
    return this.storageService.uploadFile(
      file,
      `incidences/${incidenceId}/files`,
      `incidences/${incidenceId}/files`
    );
  }

  /**
   * Creates a new incidence in Firestore
   * @param incidence Incidence object with the customer comment and the attached files
   * @returns Promise that resolves with the new incidence's Firestore document ID
   */
  createIncidence(incidence: IncidenceUI): Promise<string> {
    return this.incidenceDbService.create(incidence);
  }
}
